import { css } from "../helpers/webComponents";
import { InventoryService, InventoryState } from "../services/InventoryService";

const style: string = css`
        .slot { 
            border: solid 2px #ffffff99;
            background-color: #4b628b81;
            border-radius: 5px;
            height: 100px;
            width: 100px;
            cursor: pointer;
            box-sizing: border-box;
            text-align: center;
            align-content: center;
        }

        .slot:hover {
            background-color: #332c57;
        }
`;

export class InventoryComponent extends HTMLElement {
    private readonly _inventoryService: InventoryService = new InventoryService();

    private inventoryItems: InventoryState = { inventory: [] };

    public async connectedCallback(): Promise<void> {
        this.attachShadow({ mode: "open" });
        await this.render();
    }

    private async render(): Promise<void> {
        if (!this.shadowRoot) {
            return;
        }

        this.shadowRoot.innerHTML = `
        <style>
            ${style}
        </style>
        `;

        for (let i: number = 0; i < 10; i++) {
            this.shadowRoot.innerHTML += `<div class="slot" id="${i}"></div>`;
        }

        this.inventoryItems = await this._inventoryService.getInventory();

        for (let i: number = 0; i < this.inventoryItems.inventory.length; i++) {
            const inventorySlot: HTMLElement | null = this.shadowRoot.getElementById(`${i}`);
            if (inventorySlot) {
                inventorySlot.style.backgroundImage = `url('${this.inventoryItems.inventory[i]}')`;
                inventorySlot.style.backgroundSize = "cover";
            }
        }
    }
}
